import React, { ComponentProps } from "react";
import { ThemeVariant } from "../../utils/constants/generic-types";

interface ApplePayIconProps extends ComponentProps<"svg"> {
  variant?: ThemeVariant;
}

export default function ApplePayIcon({
  variant = ThemeVariant.DARK,
  ...props
}: ApplePayIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="21"
      viewBox="0 0 36 21"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_3773_85570)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.39179 5.04255C6.98162 5.53342 6.32524 5.92054 5.66886 5.86521C5.58679 5.20154 5.90808 4.49644 6.28421 4.06099C6.69437 3.55631 7.4123 3.19681 7.99352 3.16919C8.06188 3.86048 7.79524 4.53796 7.39179 5.04255ZM7.98661 5.99658C7.40842 5.96294 6.88078 6.17239 6.45457 6.34159C6.18035 6.4505 5.94804 6.54269 5.77136 6.54269C5.57308 6.54269 5.33124 6.44554 5.05974 6.33644C4.70394 6.19359 4.29718 6.03023 3.87058 6.03801C2.89291 6.05191 1.98351 6.61183 1.48437 7.50353C0.458764 9.28714 1.21773 11.9278 2.20911 13.3795C2.69464 14.0984 3.27575 14.8866 4.04153 14.8589C4.37847 14.846 4.6208 14.7421 4.87158 14.6344C5.16029 14.5106 5.46028 14.3819 5.92859 14.3819C6.38077 14.3819 6.66763 14.5072 6.94292 14.6275C7.20469 14.742 7.45616 14.8518 7.82937 14.8451C8.62257 14.8313 9.12162 14.1262 9.60714 13.4072C10.131 12.6355 10.3612 11.8825 10.3962 11.7683L10.4002 11.755C10.4002 11.755 10.3929 11.7511 10.3815 11.7459C10.2063 11.6648 8.86782 11.0453 8.85498 9.38389C8.84214 7.98945 9.91666 7.28289 10.0859 7.17165C10.0962 7.16484 10.1031 7.16027 10.1062 7.15794C9.42248 6.13486 8.35584 6.0242 7.98661 5.99658ZM13.477 14.769V3.99185H17.4768C19.5417 3.99185 20.9844 5.42966 20.9844 7.53125C20.9844 9.63273 19.5143 11.0844 17.4221 11.0844H15.1316V14.769H13.477ZM15.1316 5.40205H17.0392C18.4751 5.40205 19.2955 6.17628 19.2955 7.53815C19.2955 8.90002 18.4751 9.68116 17.0324 9.68116H15.1316V5.40205ZM26.4473 13.4763C26.0097 14.3197 25.0457 14.852 24.0065 14.852C22.468 14.852 21.3946 13.9256 21.3946 12.5293C21.3946 11.1467 22.4339 10.3517 24.3552 10.2342L26.42 10.1097V9.51526C26.42 8.63727 25.8525 8.1603 24.8406 8.1603C24.0065 8.1603 23.3979 8.59585 23.2748 9.25942H21.7843C21.8321 7.86303 23.1313 6.84686 24.8884 6.84686C26.7823 6.84686 28.0131 7.84923 28.0131 9.4046V14.769H26.4815V13.4763H26.4473ZM24.4508 13.5731C23.5689 13.5731 23.0082 13.1445 23.0082 12.4877C23.0082 11.8104 23.5484 11.4162 24.5808 11.3541L26.42 11.2365V11.8449C26.42 12.8541 25.5721 13.5731 24.4508 13.5731ZM33.0932 15.1908C32.43 17.0779 31.671 17.7001 30.0574 17.7001C29.9344 17.7001 29.5241 17.6863 29.4283 17.6587V16.3659C29.5309 16.3797 29.784 16.3935 29.9139 16.3935C30.6454 16.3935 31.0557 16.0825 31.3086 15.2737L31.459 14.7966L28.6558 6.95052H30.3856L32.3342 13.3173H32.3684L34.3171 6.95052H35.999L33.0932 15.1908Z"
          fill={variant === ThemeVariant.DARK ? "black" : "white"}
        />
      </g>
      <defs>
        <clipPath id="clip0_3773_85570">
          <rect
            width="36"
            height="20"
            fill={variant === ThemeVariant.DARK ? "black" : "white"}
            transform="translate(0 0.0290527)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
